import { render, staticRenderFns } from "./MaskAdjust.vue?vue&type=template&id=1b0d4874&"
import script from "./MaskAdjust.vue?vue&type=script&lang=ts&"
export * from "./MaskAdjust.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports